module.exports = __webpack_public_path__ + "img/modulo_Boton.5212bb1.svg";